import React,{ useState,useEffect } from "react";
import CText from "./CText";
import { View, TouchableOpacity, TextInput } from "react-native";
import CImage from "./CImage";
import { getCpatcha } from "../api/apiManager";
import { decryptCaptcha } from "../utilities/Encryption";
import RootNavigation from "../utilities/RootNavigation";
import { CreateResponsiveStyle, DEVICE_SIZES} from "rn-responsive-styles";

const CCaptcha = (props) => {
  const styles = useStyles();
  const [captchaText, setCaptchaText] = useState("");

  const generateCaptcha = () => {
    props.setCaptcha("")
    getCpatcha()
      .then((res) => {
        decryptCaptcha(res?.data).then((res) => {
          setCaptchaText(res?.captchaCode)
          props.setCaptchaId(res?.captchaId)
          props?.setCaptchaText(res?.captchaCode)
        });
      }).catch((err) => {
        const routeObj = { title: "Captcha", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
        RootNavigation.navigate("ResponseScreen", { data: routeObj })
      });
  };
  return (
    <View style={styles.captchaWrapper}>
      <View style={styles.captchaTextWrapper}>
        <CText.activeCapchaStyle style={{ paddingLeft: 4 }}>{props.captchaText} </CText.activeCapchaStyle>
      </View>
      <View style={styles.captchaInputWidget}>
        <TextInput
          value={props.captcha}
          onChangeText={(t) => props.setCaptcha(t.replace(/[^0-9a-zA-Z]+/gi, ''))}
          maxLength={7}
          placeholder={'Enter captcha code'}
          style={styles.captchaInputStyle}
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
        />
        <TouchableOpacity
          onPress={generateCaptcha}
          style={styles.reloadCaptcha}>
          <CImage.ReloadCaptchaIcon></CImage.ReloadCaptchaIcon>
        </TouchableOpacity>
      </View>
    </View>
  );
};
  const useStyles = CreateResponsiveStyle( {
    reloadCaptcha:{ width: "20%", height: 40, justifyContent: "center",},
    captchaWrapper:{flexDirection:"row",width: "100%",height: 40,borderRadius: 10,borderWidth: 1,marginTop: 30,borderColor: "#cccccc",},
    captchaTextWrapper:{alignItems:"center",width: "40%",borderRightWidth: 1,borderRightColor: "#cccccc",justifyContent: "center",},
    captchaInputWidget:{width:"60%",flexDirection: "row",backgroundColor: "#f3f3f3",alignItems: "center",justifyContent: "center",borderTopRightRadius: 10,borderBottomRightRadius: 10,justifyContent: "center",},
    captchaInputStyle: {
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 8.4,
        letterSpacing: 0,
        textAlign: "left",
        color: "#999999",
        alignSelf: "center",
        width: "100%",
        height: "100%",
        textAlign: "center",
      },

});


export default CCaptcha;
